/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { setSentryUser, clearSentryUser } from "../config/sentry";

// ------------------------------------
// Constants
// ------------------------------------

const initialState = {
  admin: {
    id: "",
    username: "",
    role: "",
    active: false,
    deleted: false,
    authentication: {},
  },
  student: {
    id: "",
    profile_icon: "",
    student_card_image_url: "",
    student_card_number: "",
    student_card_name: "",
    hkid_image_url: "",
    hkid_number: "",
    hkid_name: "",
    username: "",
    university_email: "",
    gender: "",
    university: "",
    university_number: "",
    year_of_study: "",
    identity: "",
    phone_num: "",
    bachelor_degree_id: "",
    bachelor_degree: "",
    expiry_date: "",
    society_id: [],
    user_auth: "",
    active: "",
    deleted: "",
    access_token: "",
    utime: "",
    ctime: "",
  },
  business: {
    id: "",
    user_id: "",
    br_image: "",
    br_number: "",
    company_address: "",
    company_email: "",
    company_name: "",
    contact_number: "",
    user_auth: "",
    utime: "",
    ctime: "",
  },
  app_key: "",
  loggedIn: false,
  user_auth: "",
  access_token: "",
  push_notification_token: "",
  selectCalendar: false,
  // Set dynamically by autoLogin/editUserInfo reducers; absent until a user logs in.
  user: undefined,
  tagList: [] as any[],
  filterSociety: [] as any[],
  filterUniversity: [] as any[],
  filterGender: [] as any[],
  filterIdentity: [] as any[],
  filterYearOfStudy: [] as any[],
};

// ------------------------------------
// Slice
// ------------------------------------

const authSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    autoLogin: (state, { payload }) => {
      if (payload.userType === "student") {
        state.student = payload.user;
        state.user = payload.user;
      } else if (payload.userType === "business") {
        state.business = payload.user;
        state.user = payload.user;
      } else if (payload.userType === "admin") {
        state.admin = payload.user;
        state.user = payload.user;
      }
      state.access_token = payload.access_token;
      // Set Sentry user context for error tracking
      if (payload.user?.id) {
        setSentryUser(payload.user.id, payload.user.email, payload.userType);
      }
    },
    editUserInfo: (state, { payload }) => {
      if (payload.userType === "student") {
        state.student = payload.user;
        state.user = payload.user;
      } else if (payload.userType === "business") {
        state.business = payload.user;
        state.user = payload.user;
      }
    },
    setAppKey: (state, { payload }) => {
      state.app_key = payload.app_key;
    },
    setPushNotificationToken: (state, { payload }) => {
      state.push_notification_token = payload.push_notification_token;
    },
    authenticate: (state, { payload }) => {
      state.loggedIn = payload.loggedIn;
      state.user_auth = payload.user_auth;
    },
    logout: (state) => {
      state.student = initialState.student;
      state.business = initialState.business;
      state.admin = initialState.admin;
      delete state.user;
      state.loggedIn = initialState.loggedIn;
      state.user_auth = initialState.user_auth;
      state.access_token = initialState.access_token;
      state.push_notification_token = initialState.push_notification_token;
      clearSentryUser();
    },
    countTagList: (state, { payload }) => {
      state.tagList = payload.tagList;
    },
    filter: (state, { payload }) => {
      state.filterSociety = payload.filterSociety;
      state.filterUniversity = payload.filterUniversity;
      state.filterGender = payload.filterGender;
      state.filterIdentity = payload.filterIdentity;
      state.filterYearOfStudy = payload.filterYearOfStudy;
    },
    calendarState: (state, { payload }) => {
      state.selectCalendar = payload.selectCalendar;
    },
  },
});

export const {
  autoLogin,
  editUserInfo,
  authenticate,
  setAppKey,
  setPushNotificationToken,
  logout,
  countTagList,
  filter,
  calendarState,
} = authSlice.actions;

export default authSlice.reducer;